import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPreviousPathname } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { getPreviousLocation } from '../../../selectors/location-history-selectors';
import Page from '../../../components/page';
import { FullHeightLayout, SimpleLayout } from '../../../components/layout';
import EmptyStates from '../../../components/empty-states';
import Button from '../../../components/button';
import Link from '../../../components/link/internal-link';
import AppLoaded from '../../../components/app-loaded';
import forDevice from '../../../hoc/for-device';
import withTranslate from '../../../hoc/with-translate';

const Layout = forDevice(FullHeightLayout, SimpleLayout);

export class ServerErrorPage extends Component {
  render() {
    const { t, previousPathname, previousLocation } = this.props;
    const tryAgainPathname = previousLocation ? previousLocation.pathname : previousPathname;
    return (
      <Page noSpacing>
        <Layout>
          <EmptyStates title={t('server-error-page.title')} content={t('server-error-page.text')}>
            {tryAgainPathname && (
              <Button component={Link} to={tryAgainPathname}>
                {t('server-error-page.try-again-button')}
              </Button>
            )}
          </EmptyStates>
        </Layout>
        <AppLoaded />
      </Page>
    );
  }
}

ServerErrorPage.propTypes = {
  t: PropTypes.func.isRequired,
  previousPathname: PropTypes.string,
  previousLocation: PropTypes.object,
};

const mapStateToProps = state => ({
  previousPathname: getPreviousPathname(state),
  previousLocation: getPreviousLocation(state),
});

export default flowRight(
  connect(mapStateToProps),
  withTranslate,
)(ServerErrorPage);
